import { Questions as QuestionSkeletons } from "../../Skeletons/Question";
import ViewWithPagination from "../ViewWithPagination";
import QuestionView from "./QuestionView";

function QuestionsList(props) {
	if (props.isLoading) {
		return <QuestionSkeletons />;
	}

	const renderList = () => {
		return props.data.map((question, index) => (
			<div key={question.id} className="search-question-card">
				<QuestionView
					key={question.id}
					className="question-view--flat"
					question={question}
					answers={props.answers}
					setAnswer={props.setAnswer}
					searchValue={props.searchValue}
				/>
				{index < props.data.length - 1 && (
					<div className="divider divider--horizontal divider--search--question" />
				)}
			</div>
		));
	};

	return (
		<ViewWithPagination {...props}>
			<div className="search-elements--list">{renderList()}</div>
		</ViewWithPagination>
	);
}

export default QuestionsList;
